import { render, staticRenderFns } from "./SUMITCoordinatorView.vue?vue&type=template&id=07c9ba71&scoped=true"
import script from "./SUMITCoordinatorView.vue?vue&type=script&lang=js"
export * from "./SUMITCoordinatorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c9ba71",
  null
  
)

export default component.exports